<template>
  <div>

  </div>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    name: "ServiceAssignDriver",
    components: {

    },
    data() {
      return {
        active:!!this.serviceId,
        driverId: '',
        selectedDriver: ''
      }
    },
    mounted() {
    },
    computed: {
      drivers() {
        return this.$store.state.drivers.map(i => {
          return {
            label: i.firstName + '' + i.lastName,
            value: i.id
          }
        })
      }
    },
    methods: {

    },
    watch: {
      serviceId(val){
        this.active = !!val
      },

    },
    props:{
      serviceId : [Number]
    }
  }
</script>

<style scoped>

</style>
